import { eff } from "@/core/utils/effect-ts-abbr";
import { formatUnit } from "@/core/utils/format-unit";
import { Prop, Vue } from "vue-property-decorator";

export class AppFormatUnitComponent extends Vue {
    @Prop({ required: true })
    value!: bigint | number;

    @Prop({ default: "kilometer", type: String })
    unit!: Intl.NumberFormatOptions["unit"];

    @Prop()
    options?: Omit<Intl.NumberFormatOptions, "style">;

    get formattedValue() {
        return eff.fn.pipe(
            this.value,
            formatUnit({ ...(this.options || {}), unit: this.unit }),
        );
    }
}
